import React from 'react';

/**
 * Page header with title, optional subtitle, and optional right-side action.
 */
export default function PgHeader({ title, sub, action }) {
  return (
    <div className="v2-pg-header">
      <div>
        <h1 className="v2-pg-header__title">{title}</h1>
        {sub && <div className="v2-pg-header__sub">{sub}</div>}
      </div>
      {action && <div className="v2-pg-header__action">{action}</div>}
    </div>
  );
}
